import { loadCachedImage } from "#/game/cachedImage";

export type HpBadgeValue = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

const HP_BADGE_VALUES = [1, 2, 3, 4, 5, 6, 7, 8, 9] as const;

export function hpBadgeUrl(value: HpBadgeValue): string {
  return `/badges/${value}.png`;
}

function cargoBadgeUrl(): string {
  return "/badges/cargo.png";
}

export function isHpBadgeValue(value: number): value is HpBadgeValue {
  return Number.isInteger(value) && value >= 1 && value <= 9;
}

export function getHpBadgeImage(value: HpBadgeValue): HTMLImageElement {
  return loadCachedImage(hpBadgeUrl(value));
}

export function getCargoBadgeImage(): HTMLImageElement {
  return loadCachedImage(cargoBadgeUrl());
}

export function preloadBadgeSprites(): HTMLImageElement[] {
  return [...HP_BADGE_VALUES.map(getHpBadgeImage), getCargoBadgeImage()];
}
